export const ADJUSTMENT_REASON_OTHER = "OTHER";
